<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Государственный магазин</h3>
		</header>
		<p><b>Государственный магазин</b> - место, где можно приобрести вещи, которые не производятся и не добываются в игре.</p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisShop',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>